export default __webpack_public_path__ + "static/media/dreamfest (1).4ab0f79c.jpg";